// Library Methods
import axios from "axios";

// Utils
import {
  apiGatewayUrl,
  gatewayConfig,
} from "src/utils/services/servicesHelper";

// Types
import { EmrHubInstallerDownloadLinkType } from "./types";

const getEmrHubInstallerDownloadLink = async (
  accessToken: string | null,
  clinicId: string
): Promise<EmrHubInstallerDownloadLinkType> => {
  try {
    const { data } = await axios.get(
      `${apiGatewayUrl}/emr/portal/installer/download-link`,
      gatewayConfig(accessToken, clinicId)
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export { getEmrHubInstallerDownloadLink };
